export default "__VITE_ASSET__CAEjfFmq__"